module.exports = __webpack_public_path__ + "static/downtown-dos-164ed2af9fdd672e62a52f846c8bd3fd.png";